import React, { useState } from "react";
import { Button, H1, Paragraph, View, XStack, YStack } from "tamagui";
import ThemedSpinner from "./spinner";
import TamaguiInput from "./tamagui-input";

const TamaguiExample: React.FC = () => {
  const [formValues, setFormValues] = useState({
    username: "",
    password: "",
    email: "",
  });

  const handleChange = (field: string, value: string) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <YStack
      padding="$6"
      backgroundColor="$beige100"
      borderRadius="$4"
      space="$4"
    >
      <H1 color="$terracotta600" fontFamily="$heading">
        Harper Styling with Tamagui
      </H1>

      <Paragraph color="$brown800" fontFamily="$body">
        This component uses the Harper brand colors defined in our Tamagui
        configuration. You can use all the Tamagui components and styling props
        directly in your JSX.
      </Paragraph>

      <YStack space="$4" marginTop="$4">
        <H1 color="$terracotta600" fontSize="$6">
          Form Inputs
        </H1>

        <TamaguiInput
          label="Username"
          placeholder="Enter your username"
          value={formValues.username}
          onChange={(e) => handleChange("username", e.nativeEvent.text)}
          fullWidth
          helperText="Your unique username for the application"
        />

        <TamaguiInput
          label="Password"
          placeholder="Enter your password"
          inputType="password"
          value={formValues.password}
          onChange={(e) => handleChange("password", e.nativeEvent.text)}
          fullWidth
          helperText="Must be at least 8 characters long"
        />

        <TamaguiInput
          label="Email"
          placeholder="Enter your email"
          inputType="email"
          value={formValues.email}
          onChange={(e) => handleChange("email", e.nativeEvent.text)}
          fullWidth
        />

        <TamaguiInput
          label="Password (No Toggle)"
          placeholder="Enter your password"
          inputType="password"
          showPasswordToggle={false}
          fullWidth
          helperText="Password with disabled toggle"
        />

        <TamaguiInput
          label="Numeric Input"
          placeholder="Enter a number"
          inputType="number"
          fullWidth
          helperText="Numbers only"
        />

        <TamaguiInput
          label="Error Example"
          placeholder="Enter a value"
          error="This field has an error"
          fullWidth
        />
      </YStack>

      <XStack>
        <ThemedSpinner />
      </XStack>

      <XStack flexWrap="wrap" space="$3" marginTop="$4">
        <Button backgroundColor="$terracotta500" color="white">
          Terracotta Button
        </Button>

        <Button backgroundColor="$beige500" color="$brown800">
          Beige Button
        </Button>

        <Button backgroundColor="$cream500" color="$brown800">
          Cream Button
        </Button>

        <Button backgroundColor="$brown200" color="white">
          Brown Button
        </Button>
      </XStack>

      <View
        height={100}
        backgroundColor="$terracotta500"
        borderRadius="$4"
        justifyContent="center"
        alignItems="center"
      >
        <Paragraph color="white" fontWeight="bold">
          Primary Color Block
        </Paragraph>
      </View>
    </YStack>
  );
};

export default TamaguiExample;
